import type { HTMLAttributes } from "react";
import { forwardRef } from "react";
import { WithChildren } from "../../types";
import styles from "./Section.module.css";

type SectionProps = WithChildren &
  HTMLAttributes<HTMLElement> & {
    onClick?: () => void;
    disabled?: boolean;
    // Columns in the 12-column grid of the desktop layout. Defaults to all 12.
    span?: 4 | 8 | 12;
    variant?: "card" | "petrol";
  };

const Section = forwardRef<HTMLElement, SectionProps>(({ children, className, span, variant, ...props }, ref) => (
  <section
    className={[styles.section, span && span !== 12 && styles[`span${span}`], variant && styles[variant], className].filter(Boolean).join(" ")}
    ref={ref}
    {...props}
  >
    {children}
  </section>
));

Section.displayName = "Section";

export default Section;
